import { useIntl } from 'react-intl';
import { FunctionRuntime } from '@rossum/api-client/hooks';
import { Chip, Tooltip } from '@rossum/ui/material';
import { runtimesConfig } from '../config';

type Props = {
  runtime: FunctionRuntime;
};

export const RuntimeChip = ({ runtime }: Props) => {
  const intl = useIntl();

  const runtimeConfig = runtimesConfig[runtime];
  const deprecationDate =
    ('deprecationDate' in runtimeConfig && runtimeConfig.deprecationDate) ||
    undefined;

  return (
    <Tooltip
      placement="top"
      title={
        deprecationDate
          ? intl.formatMessage(
              {
                id: 'containers.settings.extensions.function.runtime.deprecatedWarning.tooltip',
              },
              {
                deprecatedDate: intl.formatDate(deprecationDate, {
                  dateStyle: 'medium',
                }),
              }
            )
          : intl.formatMessage({
              id: 'containers.settings.extensions.function.runtime.chip.tooltip',
            })
      }
    >
      <Chip
        data-cy="extension-runtime-tag"
        label={runtime}
        color={deprecationDate ? 'warning' : 'default'}
      />
    </Tooltip>
  );
};
